module.exports = __webpack_public_path__ + "47b461c526e5c4ae670293fc9c4f9ce5.png";